import * as React from 'react'

import {useSelector} from 'react-redux'

import urlIsValid from 'airship/modules/url-is-valid'
import Box from 'airship/patterns/Box'
import Button from 'airship/patterns/button'
import Label from 'airship/patterns/label'
import TextInput from 'airship/patterns/TextInput'

import detailsSlice from './detailsSlice'
import {selectAppName, selectUrl, selectAppKey} from './selectors'
import {DetailsData} from './index'
import {useInProductSupportDispatch} from './store'

export interface EditDetailsProps {
  setShowEditDetails: (val: boolean) => void
}

const EditDetails: React.FC<EditDetailsProps> = ({setShowEditDetails}) => {
  const dispatch = useInProductSupportDispatch()

  const appName = useSelector(selectAppName)
  const url = useSelector(selectUrl)
  const appKey = useSelector(selectAppKey)

  const [projectName, setProjName] = React.useState<string>(appName)
  const [webAdd, setWebAdd] = React.useState<string>(url)
  const [appK, setAppK] = React.useState<string>(appKey)
  const [errorUrl, setErrorUrl] = React.useState<string>('')

  React.useEffect(() => {
    setProjName(appName)
    setWebAdd(url)
    setAppK(appKey)
  }, [appName, url, appKey])

  const changeEditDetails = (newDetails: DetailsData): void => {
    dispatch(detailsSlice.actions.updateDetails(newDetails))
  }

  const handleUpdate = (): void => {
    if (!webAdd) {
      setErrorUrl('This field is required.')
      return
    }

    if (!urlIsValid(webAdd)) {
      setErrorUrl('This must be a valid URL.')
      return
    }

    changeEditDetails({
      appName: projectName.trim(),
      url: webAdd.trim(),
      appKey: appK.trim(),
    })
    setShowEditDetails(false)
    dispatch(detailsSlice.actions.clearErrorMessage())
  }

  return (
    <>
      <Box displayClasses="u-bg-grey-40 u-border-none u-border-radius-md u-pad-top-05">
        <Label text="Project name">
          <TextInput
            displayClasses="u-bg-white u-space-bottom-05"
            id="project-name"
            value={projectName}
            onChange={setProjName}
          />
        </Label>
        <Label text="Page URL">
          <TextInput
            displayClasses="u-bg-white u-space-bottom-05"
            id="web-address"
            value={webAdd}
            onChange={setWebAdd}
          />
        </Label>
        {errorUrl && <span className="u-orange">{errorUrl}</span>}
        <div className="u-flex">
          <p className="u-text-bold u-text-shrink-1 u-space-bottom-05 u-space-right-1">
            App key
          </p>
          <a
            href="https://docs.airship.com/guides/messaging/user-guide/admin/security/app-keys-secrets/"
            target="_blank"
            rel="noopener noreferrer"
          >
            What is this?
          </a>
        </div>
        <TextInput
          name="AppKey"
          displayClasses="u-bg-white u-space-bottom-1"
          id="app-key"
          value={appK}
          onChange={setAppK}
        />

        <div className="u-flex">
          <Button
            onClick={() => handleUpdate()}
            style="navy"
            displayClasses="u-space-right-05"
          >
            Update details
          </Button>
          <Button
            displayClasses="u-bg-grey-50"
            onClick={() => setShowEditDetails(false)}
          >
            Cancel
          </Button>
        </div>
      </Box>
    </>
  )
}

export default EditDetails
